import { render, staticRenderFns } from "./reportDetailNew.vue?vue&type=template&id=6ad48147&scoped=true"
import script from "./reportDetailNew.vue?vue&type=script&lang=js"
export * from "./reportDetailNew.vue?vue&type=script&lang=js"
import style0 from "./reportDetailNew.vue?vue&type=style&index=0&id=6ad48147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad48147",
  null
  
)

export default component.exports